// Gradient pairs for folder "wallet" cards. Each start colour keeps white
// text at >= 4.5:1 contrast.
export const FOLDER_GRADIENTS: [string, string][] = [
  ['#5B42D6', '#2A1F74'], // violet
  ['#0F7684', '#0A3553'], // teal
  ['#C2477A', '#561C50'], // magenta
  ['#A85A22', '#4F2414'], // amber
  ['#3B6FD8', '#1A2D6B'], // blue
  ['#287A50', '#103826'], // green
  ['#8A4FD0', '#3B1C66'], // purple
  ['#B8434A', '#521A22'], // red
]

export const ALL_ITEMS_GRADIENT: [string, string] = ['#3A3756', '#1A1928']

function hash(input: string): number {
  let h = 0
  for (let i = 0; i < input.length; i++) {
    h = (h * 31 + input.charCodeAt(i)) | 0
  }
  return Math.abs(h)
}

/** Stable gradient for a folder (or vault) id. */
export function gradientFor(id: string | null | undefined): [string, string] {
  if (!id) return ALL_ITEMS_GRADIENT
  return FOLDER_GRADIENTS[hash(id) % FOLDER_GRADIENTS.length]
}

/** Inline style that sets --c1/--c2 for `.gcard`, `.modal-glow` etc. */
export function gradientStyle(id: string | null | undefined) {
  const [c1, c2] = gradientFor(id)
  return { '--c1': c1, '--c2': c2 } as React.CSSProperties
}

/** Pointer-follow highlight: writes --mx/--my on the hovered element. */
export function trackPointer(e: React.PointerEvent<HTMLElement>) {
  if (e.pointerType !== 'mouse') return
  const el = e.currentTarget
  const r = el.getBoundingClientRect()
  el.style.setProperty('--mx', `${e.clientX - r.left}px`)
  el.style.setProperty('--my', `${e.clientY - r.top}px`)
}

export function groupVaultId(id: string): string {
  return id.replace(/(.{5})(?=.)/g, '$1 ')
}
